import { StaticImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"

function SuccessStoryCard() {
  return (
    <div
      sx={{
        width: ["100vw", "100%"],
        position: "relative",
        left: ["50%", 0],
        mr: [null, "auto"],
        ml: ["-50vw", 0],
        overflow: "hidden",
        bg: "#FFFFFF",
        borderRadius: "32px",
        p: "26px",
        mb: 4,
        textAlign: "center",
      }}
    >
      <Heading
        as="h3"
        sx={{ lineHeight: 1.444, fontWeight: "bold", fontSize: 3, mb: 2 }}
      >
        Echte Menschen – Echte Erfolge
      </Heading>

      <p
        sx={{
          fontSize: 1,
          mb: 4,
          lineHeight: 1.428,
        }}
      >
        Nach schon 12 Behandlungswochen feiern unsere Patient:innen erste
        sichtbare Erfolge.
      </p>

      <div
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
          mb: 4,
          width: "100%",
        }}
      >
        <StaticImage
          src="../images/miriam-before-after.webp"
          alt="Vorher und Nachher – Miriam"
          placeholder="none"
        />
      </div>

      <p
        sx={{
          fontSize: 1,
          fontWeight: "bold",
          lineHeight: 1.428,
          mb: 1,
        }}
      >
        Miriam, <span sx={{ fontSize: 1, fontWeight: 400 }}>FORMEL SKIN</span>
      </p>
      <p sx={{ fontSize: 1, color: "#767676", m: 0 }}>
        Eine von 5.000+ tollen Bewertungen
      </p>
    </div>
  )
}

export default SuccessStoryCard
